/**
 * Flow Books brand tokens — the single source of truth shared by the web app
 * (src/styles.css mirrors these as CSS variables) and the PDF generator.
 *
 * The two-rust rule: `rust` is the accent on light backgrounds. On charcoal it
 * lacks contrast, so dark surfaces use `terracotta` instead. Never both on one
 * surface.
 */
export const COLORS = {
  charcoal: "#33312A",
  cream: "#F5F1E6",
  rust: "#C25B33",
  terracotta: "#D98A63",
  stone: "#6B6553",
  peach: "#EFD8C4",
  nearBlack: "#181711",

  // supporting shades used in layouts
  pageCream: "#EDEAE0",
  paper: "#FDFCF8",
  hairline: "#E2DBCA",
  labelGrey: "#9A9279",
  labelOnDark: "#B3AD9A",
  inkOnDark: "#F4F0E6",
};

/** Accent pair for a given surface. */
export const tone = (surface = "light") =>
  surface === "dark"
    ? { ink: COLORS.inkOnDark, accent: COLORS.terracotta }
    : { ink: COLORS.charcoal, accent: COLORS.rust };

/** #RRGGBB -> {r,g,b} in 0..1, for pdf-lib's rgb(). */
export const toRgb = (hex) => {
  const h = hex.replace("#", "");
  return {
    r: parseInt(h.slice(0, 2), 16) / 255,
    g: parseInt(h.slice(2, 4), 16) / 255,
    b: parseInt(h.slice(4, 6), 16) / 255,
  };
};

export const TYPE = {
  headline: "Source Serif 4",
  ui: "Instrument Sans",
  label: "IBM Plex Mono",
};
